module.exports = __webpack_public_path__ + "img/mk-gigforce-creative.12e7aaa5.png";